import React, { useState } from "react";
import styles from "./Referal.module.scss";
import { Link } from "react-router-dom";
import CurrentAccModal from "../current-acc-modal/CurrentAccModal";
import AcceptReferalModal from "../accepct-referal-modal/AcceptReferalModal";
import close from "../../../../../assets/images/referal/Close Icon.svg";
import TitleUpdater from "../../../../shared/title/TitleUpdater";
import { useSite } from "../../../../../context/TranslationContext";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
interface ModalProps {
  visible: boolean;
  onClose: () => void;
  className?: string;
  onlyConfirm?: boolean;
}

const ReferalModal: React.FC<ModalProps> = ({
  visible,
  onClose,
  className = "",
  onlyConfirm,
}) => {
  const { data } = useSelector((state: RootState) => state.translationData);

  const [showExtraModal, setShowExtraModal] = useState(false);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  if (!visible) return null;
  return (
    <>
      <TitleUpdater
        title={
          data?.colibri && data?.auth_referal_create_account
            ? `${data?.colibri} | ${data?.auth_referal_create_account}`
            : "Colibri"
        }
      />
      <div className={styles.background} onClick={onClose}>
        <div
          className={`${styles.information_modal} ${className}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button onClick={onClose} className={styles.closeBtn}>
            <img src={close} alt="" />
          </button>

          <h3>{data?.auth_referal_switch_accounts}</h3>
          <div className={styles.buttonContainer}>
            {!onlyConfirm && (
              <>
                <Link to="/account/referal/newreferal" onClick={onClose}>
                  <button className={styles.buttonGreen}>
                    {data?.auth_referal_create_account}
                  </button>
                </Link>
                <Link to="/account/referal/referal_accounts" onClick={onClose}>
                  <button onClick={onClose} className={styles.buttonOrange}>
                    {data?.auth_referal_access_account}
                  </button>
                </Link>

                <button
                  className={styles.buttonRed}
                  onClick={() => {
                    setShowExtraModal(true);
                  }}
                >
                  {data?.auth_referal_add_existing}
                </button>
              </>
            )}
            <button
              className={styles.buttonGray}
              onClick={() => {
                setShowAcceptModal(true);
              }}
            >
              {data?.auth_referal_confirm}
            </button>
          </div>
        </div>
      </div>
      {showExtraModal && (
        <CurrentAccModal
          showExtraModal={showExtraModal}
          setShowExtraModal={setShowExtraModal}
        />
      )}
      {showAcceptModal && (
        <AcceptReferalModal
          showExtraModal={showAcceptModal}
          setShowExtraModal={setShowAcceptModal}
        />
      )}
    </>
  );
};

export default ReferalModal;
